import React, { Component } from 'react';
import { XYCharts } from './components';


class AmchartsDerevo extends Component {
  constructor (props) {
    super(props);
  }
  render() {
    return (
      <div>
        { this.props.type === 'xy-charts' ? (<XYCharts id_div={ this.props.id_div } data={ this.props.data } config={ this.props.config } width={ this.props.width } height={ this.props.height } />) : "404 Not found" }
      </div>
      
    )
  }
}


export default AmchartsDerevo;